import React from "react";

import {TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useDispatch, useSelector} from "react-redux";
import {setDescription} from "../../../features/plan/planRootSlice";

const TitleGridItem = () => {
  return (
    <Grid size={12}>
      <Typography component="h1" variant="h4">
        {"Kabelschacht"}
      </Typography>
      < hr/>
    </Grid>
  );
};

const DescriptionGridItem = () => {
  const dispatch = useDispatch();
  const description = useSelector(state => state.plan.description);

  return (
    <Grid size={12}>
      <TextField
        variant="outlined"
        multiline
        minRows={2}
        fullWidth
        margin="normal"
        id="description"
        label="Schachtbezeichnung"
        name="description"
        value={description}
        onChange={e => {
          dispatch(setDescription(e.target.value));
        }}
      />
    </Grid>
  );
};

export const PlanDescriptionSection = () => {
  return (
    <Grid container spacing={1}>
      <TitleGridItem/>
      <DescriptionGridItem/>
    </Grid>
  );
};
